<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#546e7a"
      d="M30,10c0,3.313-2.687,6-6,6l0,0c-3.313,0-6-2.688-6-6l0,0c0-3.313,2.687-6,6-6l0,0C27.313,4,30,6.688,30,10L30,10z"
    />
    <path
      fill="#78909c"
      d="M37,20c0,4.417-3.581,9-8,9H19c-4.418,0-8-4.583-8-9l0,0c0-4.418,2-12,13-12l0,0C35,8,37,15.582,37,20L37,20z"
    />
    <path
      fill="#9c27b0"
      d="M29,32L29,32c0,0-1,4-5,4s-5-4-5-4S8,33.986,8,45h32C40,34.025,29,32,29,32"
    />
    <path
      fill="#ff9800"
      d="M24,38c-5,0-5-6-5-6v-6h10v6C29,32,29,38,24,38z M16,20.277V22l-1.82-1.82C13.485,20.493,13,21.188,13,22c0,1.105,0.896,2,2,2c1.105,0,2-0.895,2-2C17,21.261,16.596,20.623,16,20.277z M33.82,20.18L32,22v-1.723c-0.595,0.346-1,0.984-1,1.723c0,1.105,0.896,2,2,2c1.105,0,2-0.895,2-2C35,21.188,34.515,20.493,33.82,20.18z"
    />
    <path
      fill="#fce4ec"
      d="M18.915,32.018c-0.162,0.033-2.478,0.514-4.743,1.842c0.33,0.65,1.018,1.172,1.797,1.172c0.019,0,0.035-0.004,0.053-0.006c0.115,0,0.23-0.006,0.347-0.028c0.136-0.025,0.265-0.064,0.388-0.113c-0.083,0.053-0.162,0.113-0.238,0.182c-0.827,0.731-0.905,1.996-0.173,2.822c0.026,0.029,0.089,0.098,0.118,0.127c0.78,0.779,2.072,0.809,2.854,0.027c0.015-0.015,0.029-0.029,0.043-0.042c-0.007,0.02-0.014,0.039-0.02,0.061c-0.32,1.057,0.276,2.174,1.334,2.494c0.036,0.012,0.12,0.035,0.157,0.043c1.072,0.263,2.188-0.392,2.447-1.463c0.006-0.021,0.011-0.045,0.015-0.064c0.003,0.031,0.006,0.061,0.009,0.09c0.12,1.019,1.005,1.765,2.008,1.765c0.078,0,0.158-0.004,0.237-0.015c1.097-0.129,1.882-1.121,1.753-2.219l-0.077-0.375c0.306,0.715,1.014,1.215,1.839,1.215c0.446,0,0.854-0.152,1.188-0.398l0.006,0.008c0.051-0.039,0.091-0.084,0.137-0.125c0.036-0.033,0.074-0.063,0.108-0.1c0.059-0.06,0.109-0.126,0.159-0.192c0.027-0.036,0.056-0.071,0.081-0.11c0.043-0.068,0.079-0.139,0.114-0.211c0.022-0.047,0.046-0.09,0.065-0.139c0.026-0.068,0.046-0.139,0.065-0.211c0.015-0.057,0.031-0.111,0.042-0.17c0.012-0.066,0.016-0.137,0.02-0.205c0.004-0.049,0.015-0.096,0.015-0.146c0-0.016-0.004-0.031-0.005-0.047c-0.001-0.053-0.01-0.106-0.016-0.16c-0.009-0.082-0.017-0.164-0.034-0.243c-0.005-0.021-0.014-0.042-0.02-0.062c-0.029-0.109-0.065-0.217-0.111-0.318L30.875,36.7c-0.056-0.123-0.124-0.236-0.202-0.342l-0.001-0.004c-0.002,0-0.004-0.004-0.006-0.004c-0.063-0.086-0.127-0.168-0.202-0.243c0.316,0.209,0.692,0.332,1.099,0.332c1.104,0,2-0.895,2-2c0-0.172-0.027-0.334-0.068-0.492c-0.018-0.082-0.105-0.271-0.135-0.352C31.156,32.359,29,32,29,32s-1,4-5,4s-5-4-5-4s-0.03,0.006-0.073,0.016C18.923,32.016,18.919,32.016,18.915,32.018z"
    />
    <path
      fill="#ffb74d"
      d="M32,22v-3.816l-4-3.263l-12,3.764V22l-1-1v2c0,3.853,2.426,7.131,5.83,8.415C21.561,32.372,22.703,33,24,33c1.298,0,2.439-0.628,3.17-1.585C30.575,30.131,33,26.853,33,23v-2L32,22z"
    />
    <path
      fill="#9c27b0"
      d="M28,19c-1.066,0-1.997,0.561-2.529,1.4C25.042,20.177,24.535,20,24,20s-1.042,0.177-1.471,0.4C21.997,19.561,21.066,19,20,19c-1.655,0-3,1.344-3,3s1.345,3,3,3c1.484,0,2.71-1.083,2.95-2.5C23.266,22.253,23.697,22,24,22s0.735,0.253,1.05,0.499C25.29,23.917,26.516,25,28,25c1.655,0,3-1.344,3-3S29.655,19,28,19z"
    />
    <path
      fill="#eceff1"
      d="M20 20A2 2 0 1 0 20 24 2 2 0 1 0 20 20zM28 20A2 2 0 1 0 28 24 2 2 0 1 0 28 20z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "OldWomanIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
